"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useWishlist = void 0;

var _client = require("@apollo/client");

var _queries = require("../queries");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useWishlist = function useWishlist(_ref) {
  var addToast = _ref.addToast,
      removeToast = _ref.removeToast;

  var _useQuery = (0, _client.useQuery)(_queries.GET_CUSTOMER_WISHLIST, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-and-network'
  }),
      data = _useQuery.data;

  var refetchQueries = [{
    query: _queries.GET_CUSTOMER_WISHLIST
  }];

  var _useMutation = (0, _client.useMutation)(_queries.ADD_FAVORITE_ITEM_MUTATION, {
    refetchQueries: refetchQueries
  }),
      _useMutation2 = _slicedToArray(_useMutation, 1),
      addFavorite = _useMutation2[0];

  var _useMutation3 = (0, _client.useMutation)(_queries.REMOVE_FAVORITE_ITEM_MUTATION, {
    refetchQueries: refetchQueries
  }),
      _useMutation4 = _slicedToArray(_useMutation3, 1),
      removeFavorite = _useMutation4[0];

  var NOTIFICATIONS_MESSAGES = {
    addedSuccefully: 'Item successfully added!',
    removedSuccefully: 'Item successfully removed!'
  };

  var addToFavorites = function addToFavorites(id) {
    addFavorite({
      variables: {
        id: id
      }
    }).then(function () {
      addToast({
        type: 'success',
        title: NOTIFICATIONS_MESSAGES.addedSuccefully
      });
    });
  };

  var removeFromFavorites = function removeFromFavorites(id) {
    removeFavorite({
      variables: {
        id: id
      }
    }).then(function () {
      addToast({
        type: 'success',
        title: NOTIFICATIONS_MESSAGES.removedSuccefully,
        buttonTitle: 'undo',
        onClickButton: function onClickButton() {
          removeToast();
          addToFavorites(id);
        }
      });
    });
  };

  var updateFavoriteWishlistState = function updateFavoriteWishlistState(id, isWishlisted) {
    try {
      if (isWishlisted) {
        removeFromFavorites(id);
      } else {
        addToFavorites(id);
      }
    } catch (_unused) {
      console.error('Something went wrong');
    }
  };

  return {
    favorites: data && data.customerWishlist ? data.customerWishlist.items.map(function (_ref2) {
      var product = _ref2.product;
      return product.id;
    }) : [],
    updateFavoriteWishlistState: updateFavoriteWishlistState
  };
};

exports.useWishlist = useWishlist;